module.exports = __webpack_public_path__ + "assets/img/join2021_012.3cad3ed1.png";